<template>
    <el-row :gutter="5">
        <el-col :span="colSpan" v-for="item in setList" :key="item._id">
            <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '文本'">
                <el-input size="small" v-model="form[item.fieldName]" placeholder="请输入" style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '数字'">
                <el-input-number v-model="form[item.fieldName]" :step="0.01" controls-position="right"  :min="0"  style="width:100%;"
                    size="small"></el-input-number>
            </el-form-item>



            <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '时间'">
                <el-date-picker
                    v-model="form[item.fieldName]"
                    type="date"
                    placeholder="选择日期"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    size="small">
                </el-date-picker>

            </el-form-item>
            <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '图片'">
                 <el-upload
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload" >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>

            </el-form-item>

             <el-form-item :label="item.fieldName" :prop="item.fieldName" v-if="item.fieldType == '单选框'">
                <!-- <el-radio-group v-model="form[item.fieldName]">
                    <el-radio :label="term.mc" v-for="(term,index) in item.fieldInfo.radioScope" :key="index">{{term.mc}}</el-radio>

                </el-radio-group> -->

                <el-select v-model="form[item.fieldName]"   placeholder="请选择" size="small" style="width:100%;">
                    <el-option
                    v-for="item in item.fieldInfo.radioScope"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                    </el-option>
                </el-select>
            </el-form-item>



            <el-form-item :label="item.fieldName" :prop="item.fieldName"  v-if="item.fieldType == '复选框'">


                <el-select v-model="form[item.fieldName]" multiple clearable placeholder="请选择" size="small"  style="width:100%;">
                    <el-option
                    v-for="item in item.fieldInfo.selectScope"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                    </el-option>
                </el-select>
            </el-form-item>


        </el-col>
    </el-row>

</template>
<script>
export default {
    name:"FormItem",
    props:{
        setList:{
            type:Array,
            default:[],
        },
        form:{
            type:Object,
            default:{}
        },
        colSpan:{
            type:Number,
            default:12
        },
        mode:{
          type:String,
          default:''
        }
    },
    data(){
        return {

        }
    },

    created(){
      if(this.mode == 'create'){
          this.init();
      }
    },
    methods:{
        init(){
            for(let i = 0;i<this.setList.length;i++){
                if(this.setList[i]['fieldInfo'] && this.setList[i]['fieldInfo']['radioScope'] && this.setList[i]['fieldInfo']['radioScope'].length > 0){
                    for(let j = 0;j<this.setList[i]['fieldInfo']['radioScope'].length;j++){
                        if(this.setList[i]['fieldInfo']['radioScope'][j]['checked']){
                            this.$set(this.form,this.setList[i]['fieldName'],this.setList[i]['fieldInfo']['radioScope'][j]['label']);
                        }
                    }
                }
            }
        },
        beforeAvatarUpload(file) {
              const isJPG = file.type === 'image/jpeg';
              const isLt2M = file.size / 1024 / 1024 < 2;

              if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
              }
              if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
              }
              return isJPG && isLt2M;
        },
        handleAvatarSuccess(res, file) {
          this.imageUrl = URL.createObjectURL(file.raw);
        },
    }

}
</script>
<style scoped>
     .el-row{ display:flex; flex-wrap: wrap; }
</style>



// WEBPACK FOOTER //
// src/components/FormItem.vue